<template>
  <div class="footer">
    <span class="text-black">
      <a v-if="this.$store.getters['user/isFilterOn']({id: 'mobaku'})" @click="openNotes" class="break-all">{{$t('tour_about_mobaku')}}</a>
      © 2020- {{ $t('tour_copyright') }}
    </span>
  </div>
</template>

<script>
export default {
  data () {
    return {}
  },
  methods: {
    openNotes: function () {
      this.$store.dispatch('map/setShowDocomoMobaku', true)
    }
  }
}
</script>
